export type AiRemediationsResponsibility =
    | 'Visual Design'
    | 'UX Design'
    | 'Content Authoring'
    | 'Front-end Development';

export const AI_REMEDIATIONS_RESPONSIBILITIES: ReadonlyArray<AiRemediationsResponsibility> = [
    'Visual Design',
    'UX Design',
    'Content Authoring',
    'Front-end Development',
];
